
import { useEffect, useState } from 'react'
import { useAuth } from '../../Providers/AuthProvider'
import CustomerDataCard from '../../Components/MyAccount/CustomerPanel/CustomerDataCard'
import MainDeliveryAddressCard from '../../Components/MyAccount/MainDeliveryPanel/MainDeliveryAddressCard'
import PasswordChangeCard from '../../Components/MyAccount/PasswordPanel/PasswordChangeCard'
import CreditLimitCard from '../../Components/MyAccount/CreditLimitPanel/CreditLimitCard'
import AddressesCard from '../../Components/MyAccount/AddressesPanel/AddressesCard'
import AuthorizedPersonsCard from '../../Components/MyAccount/AuthorizedPersonsPanel/AuthorizedPersonsCard'
import UsersPanelIndex from '../../Components/MyAccount/UsersPanel/UsersPanelIndex'
import ConsentsCard from '../../Components/MyAccount/ConsentPanel/ConsentCard'
import { useCustomer } from '../../Providers/CustomerProvider'
import ScrollUpArrow from '../../Components/Components/ScrollUpArrow'
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary'
import InformationErrorModal from '../../Components/Components/Modals/InformationErrorModal'
import { useParams } from '../../Providers/ParamsProvider'
import { useWarehouse } from '../../Providers/WarehouseProvider'
import EmailInputModal from './Components/EmailInputModal'
import { toast } from 'react-toastify'
import MobileAccountNavBar from '../../Components/MobileComponents/NavBarMobile.jsx/MobileAccountNavBar'
import { AccountCurrentView } from '../../Data/PageModeEnums.ts'

import './MyAccount.css'

const MyAccountIndex = () => {
    const { authState, handleAdmitEInvoiceAgreement } = useAuth()
    const { handleGetMacroRegionalWarehouseBySiteId } = useWarehouse()
    const { creditInfo, addresses, authorizedPersons, isLoadingAddresses, isLoadingAuthorized, isLoadingCredit, handleAddPersonAuthorizedToReceiveEInvoices } = useCustomer()
    const [showEInvoicePopupObj, setShowEInvoicePopupObj] = useState({
        show: false,
        message: 'Aby wyrazić zgode na przesyłanie faktur droga elektroniczną, proszę uzupełnić pobrany szablon zgody oraz przesłać go na adres email:'
    })
    const { eInvoiceEmail0101, eInvoiceEmail0201, isMobile } = useParams()
    const [userWarehouse, setUserWarehouse] = useState(null)
    const [showChangeAgreementsModal, setShowChangeAgreementsModal] = useState(false)
    const [showChangeAgreementsModal2, setShowChangeAgreementsModal2] = useState(false)
    const [showEmailInputModal, setShowEmailInputModal] = useState(false)

    useEffect(() => {
        const fetchMainWarehouse = async () => {
            const customerMainWarehouse = await handleGetMacroRegionalWarehouseBySiteId(authState.initialSiteId)
            setUserWarehouse(customerMainWarehouse)
        }
        fetchMainWarehouse()
    }, [])

    const handleEInvoiceConsentClick = (e) => {
        e.preventDefault()
        if (authState.user.customerInfo[0].isEInvoiceConsent) {
            setShowEInvoicePopupObj({ show: true, message: 'Aby wycofać zgodę na przesyłanie faktur droga elektroniczną, proszę skontaktować się z działem obsługi pod adresem email:' })
        }
        else {
            setShowEmailInputModal(true)
        }
    }

    const handleEInvoiceEmailChange = (e) => {
        e.preventDefault()
        setShowEInvoicePopupObj({ show: true, message: 'Aby zmienić adres email do przesyłania faktur droga elektroniczną, proszę skontaktować się z działem obsługi pod adresem email:' })
    }

    const handleeInvoiceConsent = () => {
        if (!authState.user.customerInfo[0].isEInvoiceConsent) {
            let consentLink = '/Statements/TG/E-Faktury Oświadczenie TG Warszawa.pdf'
            window.open(consentLink, '_blank')
        }
        setShowEInvoicePopupObj({ show: false, message: 'Aby wyrazić zgode na przesyłanie faktur droga elektroniczną, proszę uzupełnić pobrany szablon zgody oraz przesłać go na adres email:' })
    }

    const handleInputEmailModalHide = async (email) => {
        if (email && email.trim() != '') {
            const res = await handleAddPersonAuthorizedToReceiveEInvoices(email)
            if (res) {
                toast.success('Zgoda została zarejestrowana!')
                handleAdmitEInvoiceAgreement(email)
            }
            else {
                toast.error('Błd w trakcie rejestracji zgody!')
            }
        }
        setShowEmailInputModal(false)
    }

    let eInvoiceEmail = authState.user.isOperator ? authState.selectedCustomerData.siteId === '0101' ? eInvoiceEmail0101 : eInvoiceEmail0201 : authState.user.siteId == '0101' ? eInvoiceEmail0101 : eInvoiceEmail0201

    return (
        <>
            <ErrorBoundary>
                <EmailInputModal
                    show={showEmailInputModal}
                    onHide={handleInputEmailModalHide}
                />
                {!authState.user.isOperator &&
                    <InformationErrorModal
                        show={showEInvoicePopupObj.show}
                        setShow={handleeInvoiceConsent}
                        title={'UWAGA'}
                        message={`${showEInvoicePopupObj.message} ${eInvoiceEmail}`}
                        isError={false}
                    />}
                {!authState.user.isOperator &&
                    <InformationErrorModal
                        show={showChangeAgreementsModal}
                        setShow={() => setShowChangeAgreementsModal(false)}
                        title={'UWAGA'}
                        message={`Aby wycofać wyrażoną zgodę, proszę skontaktować się z działem obsługi pod adresem email: ${userWarehouse ? userWarehouse.email : ''}`}
                    />}
                {!authState.user.isOperator &&
                    <InformationErrorModal
                        show={showChangeAgreementsModal2}
                        setShow={() => setShowChangeAgreementsModal2(false)}
                        title={'UWAGA'}
                        message={'Nie możesz wycofać tej zgody!'}
                    />}
                <div className='container-fluid-with-paddings mt-4' style={{ marginBottom: isMobile ? '80px' : '0px' }}>
                    {isMobile && <div className='mb-2'><MobileAccountNavBar currentKey={AccountCurrentView.MojeKonto} /></div>}
                    <ScrollUpArrow />
                    {isMobile ?
                        <div className='row justify-content-center'>
                            <div className='col-12 col-xxl-8 mt-2'>
                                <div className='justify-content-center'>
                                    <div className='main-container-holder'>
                                        <CustomerDataCard address={authState.user.isOperator ? authState.selectedCustomerData : authState.user.customerInfo[0]} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xxl-8 mt-2'>
                                <div className='justify-content-center'>
                                    <div className='main-container-holder'>
                                        <MainDeliveryAddressCard isLoading={isLoadingAddresses} addresses={addresses.filter(a => a.id !== '999999')} />
                                    </div>
                                </div>
                            </div>
                            {!authState.user.isOperator && <>
                                <div className='col-12 col-xxl-8 mt-2'>
                                    <div className='justify-content-center'>
                                        <div className='main-container-holder'>
                                            <PasswordChangeCard user={authState.user} />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 col-xxl-8 mt-2'>
                                    <div className='justify-content-center'>
                                        <div className='main-container-holder'>
                                            <CreditLimitCard isLoading={isLoadingCredit} creditLimit={creditInfo} />
                                        </div>
                                    </div>
                                </div>
                            </>}
                        </div> :
                        <div className='row justify-content-center' >
                            <div className='col-8'>
                                <div className='dashboard-container' >
                                    <div className='main-container-holder-card'>
                                        <CustomerDataCard address={authState.user.isOperator ? authState.selectedCustomerData : authState.user.customerInfo[0]} />
                                    </div>
                                    <div className='main-container-holder-card'>
                                        <MainDeliveryAddressCard isLoading={isLoadingAddresses} addresses={addresses.filter(a => a.id !== '999999')} />
                                    </div>
                                </div>
                            </div>
                            {!authState.user.isOperator &&
                                <div className='col-8 mt-2'>
                                    <div className='dashboard-container'>
                                        <div className='main-container-holder-card'>
                                            <PasswordChangeCard user={authState.user} />
                                        </div>
                                        <div className='main-container-holder-card'>
                                            <CreditLimitCard isLoading={isLoadingCredit} creditLimit={creditInfo} />
                                        </div>
                                    </div>
                                </div>}
                        </div>}
                    <AddressesCard />
                    <AuthorizedPersonsCard authorizedPersons={authorizedPersons.filter(p => p.custId !== '999999')} loading={isLoadingAuthorized} />
                    {authState.user.isOperator || authState.user.roles.some(item => item.roleName.toUpperCase() === 'ADMINISTRATOR') ?
                        <UsersPanelIndex /> : <></>}
                    {!authState.user.isOperator && <ConsentsCard
                        user={authState.user}
                        handleEInvoiceConsentClick={handleEInvoiceConsentClick}
                        isEInvoiceConsent={authState.user.customerInfo[0].isEInvoiceConsent}
                        setShowChangeAgreementsModal={setShowChangeAgreementsModal}
                        eInvoiceEmail={authState.user.customerInfo[0].eInvoiceEmail}
                        handleEInvoiceEmailChange={handleEInvoiceEmailChange}
                    />}
                </div>
            </ErrorBoundary>
        </>
    )

}

export default MyAccountIndex